import { FormHelper } from "./formhelper";

declare var grecaptcha: any;

const RECAPTCHAKEY = "6LeAyVMqAAAAABlsoKnYUVGTH7RUt2a5Mw-gToGe";

// Encapsulates the recaptcha functionality
export function setupRecaptcha(
    buttonId: string,
    fieldId: string,
    formhelper: FormHelper,
) {
    grecaptcha.enterprise.ready(function () {
        const button = document.getElementById(buttonId);
        if (!button) {
            console.error("Could not find button with id", buttonId);
            return;
        }
        button.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent the form from submitting immediately
            formhelper.setSubmitDisabled(true);
            grecaptcha.enterprise.execute(RECAPTCHAKEY, { action: "submit" })
                .then(function (token: string) {
                    //console.log("recaptcha token", token);
                    // Add the token to the hidden input field
                    const field = document.getElementById(
                        fieldId,
                    ) as HTMLInputElement;
                    field.value = token;
                    // manually submit the form
                    formhelper.submitManual();
                });
        });
    });
}
